var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchasePlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2008_7344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9453 93.2109C27.3159 93.2109 34.1016 86.4253 34.1016 78.0547C34.1016 69.6841 27.3159 62.8984 18.9453 62.8984C10.5747 62.8984 3.78906 69.6841 3.78906 78.0547C3.78906 86.4253 10.5747 93.2109 18.9453 93.2109Z",
    stroke: "#E1E1E1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22815 67.3375L29.6625 88.7719M24.6215 47.8011L26.5234 32.5859H85.6328L93.211 93.2109H45.1905",
    stroke: "#E1E1E1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.868 40.3125C40.868 19.3861 47.6537 3.9375 56.0243 3.9375C64.3949 3.9375 71.1805 19.3861 71.1805 40.3125",
    stroke: "#E1E1E1",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2008_7344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasePlans);
export default __webpack_public_path__ + "static/media/purchase-plans.5ab701a24175f468ad325d8f1653c804.svg";
export { ForwardRef as ReactComponent };